export const USAGE_TYPES_NAME = {
  unit: 'App\\Models\\Unit',
  company: 'App\\Models\\Company',
  user: 'App\\Models\\User',
  employer: 'App\\Models\\Employer',
  segment: 'App\\Models\\Segment',
  all: 'all',
}
